var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 4",
    viewBox: "0 0 47.65 47.65",
    id: "order-by",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5b5b5b",
    d: "M41.54 0H6.11A6.12 6.12 0 0 0 0 6.11V38.8h6.68a3 3 0 0 1 3 3v5.83h31.86a6.12 6.12 0 0 0 6.11-6.11V6.11A6.12 6.12 0 0 0 41.54 0ZM23.82 28.41H7.9a1.5 1.5 0 1 1 0-3h15.92a1.5 1.5 0 0 1 0 3Zm0-7.9H7.9a1.5 1.5 0 0 1 0-3h15.92a1.5 1.5 0 1 1 0 3Zm0-7.89H7.9a1.5 1.5 0 0 1 0-3h15.92a1.5 1.5 0 0 1 0 3Zm11.22 21.62a.55.55 0 0 1-.84 0l-4.36-5.07h1.67a.55.55 0 0 0 .55-.55V11.67a.55.55 0 0 1 .55-.55h4a.56.56 0 0 1 .56.55v16.95a.54.54 0 0 0 .55.55h1.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m0 40.43 7.92 7.22v-5.18a2 2 0 0 0-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/order-list.0be839cb8ccc6dd019a022b7074056df.svg";
export { ForwardRef as ReactComponent };